import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import banner1 from '../assets/banner1.jpg';
import banner2 from '../assets/banner2.jpeg';
import banner3 from '../assets/banner3.jpg';
import banner4 from '../assets/banner4.jpg';
import banner5 from '../assets/banner5.jpg';
import logo_icon from '../assets/logo_icon.png';
import { MdLocationPin, MdSearch } from "react-icons/md";

export default function HomeBanner1(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);

	async function init() {
		//run initializations here
		setReady(false);
		//..
		
		setReady(true);
	}

	useEffect(() => {
		init();
	}, [ ])

	if(ready) {
		return (
			<div 
				className="MainBodySection"
			>
				<div
					className=""
					style={{
						width: "100%",
						height: "calc(100vh - var(--topBarHeight))",
						backgroundImage: `url(${banner1})`,
						backgroundAttachment: 'fixed',
						backgroundSize: 'cover',
						backgroundPosition: 'center'
					}}
				>
					<div
						style={{
							width: "100%",
							height: "100%",
							background: "linear-gradient(to right, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.6) 60%, rgba(0,0,0,0) 100%)"
						}}
					>
					
						<div className="container">
							<div className="row">
								<div className="col-md-6">
									<h1
										className="font-bold text-light"
										style={{
											fontSize: "48px",
											paddingTop: "40px"
										}}
									>
										All the Best Tanzanian Hotels <br/>
										Inside One APP
									</h1>

									<div
										className="mShadow3 bg-surface"
										style={{
											width: "180px",
											height: "180px",
											borderRadius: "50%",
											marginTop: "40px"
										}}
									>
										<img
											style={{
												width: "100%",
												height: "100%"
											}}
											src={logo_icon}
										/>
									</div>

									<h6
										style={{
											fontSize: "14px",
											marginBottom: "20px"
										}}
										className="text-light font-light"
									>
										Brought to you by: 
										<span 
											className="d-block font-bold text-secondary"
											style={{
												fontSize: "18px"
											}}
										>
											ATAN GLOBAL (T) LTD
										</span>
									</h6>
								</div>

								<div 
									className="col-md-12"
								>
									<div
										style={{
											width: "100%",
											height: "auto",
											padding: "10px",
											borderRadius: "10px"
										}}

										className="bg-surface mShadow3"
									>
										<div className="row">
											<div className="col-9">
											
												<label className="form-label">Where To?</label>
												<div className="input-group mb-3">
													<span 
														className="input-group-text" id="basic-addon1"
													>
														<MdLocationPin size={32}/>
													</span>
													<input 
														type="text" 
														className="form-control" 
														placeholder="Hotel Name, Region or district" 
														aria-label="Hotel Name, Region or district" 
														aria-describedby="basic-addon1" 
														value={appContext.globalSearchFilter || ''}
														onChange={(e) => appContext.setGlobalSearchFilter(e.target.value)}
													/>
												</div>
												
											</div>

											<div className="col-3">
												<button
													className="btn btn-secondary btn-block"
													style={{
														marginTop: "32px"
													}}

													onClick={() => {
														appContext.navTo({
															item: 'hotels'
														})
													}}
												>
													<MdSearch size={30}/>
												</button>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>

					</div>
				</div>
			</div>
		)
	} else {
		return (
			<div 
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}

	
}